import React, { memo, forwardRef } from 'react'

import { util } from '../../../util'
import { Typography } from '../index'

const TextArea = (
    {
        viewOnly,
        label,
        className,
        showInputCount,
        height,
        maxLength,
        value,
        isFullWidth,
        fontSize = 'rg',
        readOnly = false,
        error,
        isModified,
        ...rest
    },
    ref
) => {
    return (
        <div
            className={util.joinClasses(
                'text-area',
                height && `height-${height}`,
                readOnly && 'read-only',
                isFullWidth && 'is-full-width',
                viewOnly && 'view-only',
                isModified && 'modified',
                className
            )}
        >
            <textarea
                ref={ref}
                className={util.joinClasses(
                    'text-area__input',
                    !!error && 'show-error',
                    viewOnly && 'view-only'
                )}
                value={value}
                maxLength={maxLength}
                readOnly={readOnly || viewOnly}
                {...rest}
            />
            <label
                className={util.joinClasses(
                    'text-area__label',
                    fontSize && `font-size-${fontSize}`,
                    !!error && 'show-error'
                )}
            >
                {label}
            </label>
            <Typography
                show={(error && error.length > 0) || false}
                text={error}
                display={'block'}
                size={'xs'}
                className={'mt-2'}
                color={'danger'}
                fontType={'medium'}
            />
            <Typography
                className={'text-area__count'}
                fontType={'light'}
                size={'xs'}
                show={!!showInputCount}
                text={`${value ? value.length : 0} / ${maxLength}`}
            />
        </div>
    )
}

export default memo(forwardRef(TextArea))
